import React, { useState, useEffect } from 'react';
import { DateTime } from 'luxon';
import moment from 'moment';
import momentTimeZone from 'moment-timezone';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  AppBar,
  Tabs,
  Tab,
  MenuItem,
  ListItemText,
  IconButton,
  Select,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
// import { useSnackbar } from 'notistack';
import Button from '../Button';
// import DateSelect from '../DateSelect';
import { DateRange } from 'react-date-range';
// import { addDays } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import ProviderSearchBar from '../ProviderSearchBar';
import TabPanel from '../TabPanel';
import TimeSelect from '../TimeSelect';
import * as api from '../../services/api/admin';

function RecurringAvailabilityEditModal(props) {
  const {
    open,
    save,
    onClose,
    classes: {
      modal,
      modalContent,
      actions,
      input,
      selectInput,
      alertText,
      btnCenter,
      calendarSection,
    },
  } = props;

  // const { enqueueSnackbar } = useSnackbar();
  const [tenancyId, setTenancyId] = useState('');
  const [dayOfWeek, setDayOfWeek] = useState('');
  // const [startsOn, setStartsOn] = useState(new Date());
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  // const [durationWeeks, setDurationWeeks] = useState('');
  const [tenancies, setTenancies] = useState([]);
  const [provider, setProvider] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [validateDate, setValidateDate] = useState(false);
  const [dateValidateMessage, setDateValidateMessage] = useState('');
  const [maxDateDisable, setMaxDateDisable] = useState(undefined);
  const [minDateDisable, setMinDateDisable] = useState(undefined);
  const [validTimeZone, setValidTimeZone] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      // endDate: addDays(new Date(), 7),
      key: 'selection',
    },
  ]);

  // For avoid dataRangePicker error?
  // We maintain two dateRangePicker for with 'America/New_York' and other timezone
  useEffect(() => {
    (async () => {
      if (momentTimeZone.tz.guess() === 'America/New_York') {
        setValidTimeZone(true);
      } else {
        setValidTimeZone(false);
      }
    })();
  }, []);

  const onProviderChange = async selectedProvider => {
    if (!provider) {
      const fetchedTenancies = await api.fetchTenancies(selectedProvider.id);
      setProvider(selectedProvider);
      setTenancies(fetchedTenancies);
      setTenancyId(fetchedTenancies[0] ? fetchedTenancies[0].id : '');
      setValidationErrors({
        ...validationErrors,
        tenancyId: false,
        provider: false,
      });
    }
  };

  const dayOfWeekMappings = [
    { monday: 1 },
    { tuesday: 2 },
    { wednesday: 3 },
    { thursday: 4 },
    { friday: 5 },
    { saturday: 6 },
    { sunday: 7 },
  ];

  const getDayOfWeekInt = () => {
    let filterDayWeekInt;
    dayOfWeekMappings.map(key => {
      if (key[dayOfWeek]) {
        filterDayWeekInt = key[dayOfWeek];
      }
    });
    return filterDayWeekInt;
  };

  const onSave = async () => {
    // Check user timezone
    const currentUserTimezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (currentUserTimezone !== 'America/New_York') {
      alert(
        '⚠️ Time Zone Mismatch Detected:\n' +
          'Kindly switch your system time zone to "America/New_York, EST" to proceed further.'
      );
      return;
    }

    const startdate = moment(dateRange[0].startDate).format('MM/DD/YYYY');
    let startDateWith = moment(new Date(startdate));
    let endDateWith = moment(dateRange[0].endDate);

    // Get Selected Day and Value of Day
    let getDayOfWeek = getDayOfWeekInt();
    let selectedDay = getDayOfWeek;
    let givenRecurringDay = [];

    //Get telemedicine id
    const telemedicineId = tenancies.find(data => data.zipcode.toLowerCase() === 'telemedicine')?.id;

    if (selectedDay === 7 && moment(startDateWith).weekday() !== 0) {
      givenRecurringDay.push(
        moment(startDateWith)
          .day(7)
          .format('MM/DD/YYYY')
      );
    } else if (selectedDay === 7 && moment(startDateWith).weekday() === 0) {
      givenRecurringDay.push(
        moment(startDateWith)
          .day(0)
          .format('MM/DD/YYYY')
      );
    }
    // for loop from starting date to end date by adding 7 days for each iteration along with isSameOrBefore condition ...
    let i = startdate;
    for (
      i;
      moment(i)
        .day(selectedDay)
        .isSameOrBefore(endDateWith, 'day');
      i = moment(i).add(7, 'd')
    ) {
      let getDate = moment(i)
        .day(selectedDay)
        .format('MM/DD/YYYY');
      if (moment(getDate).isSameOrAfter(startdate)) {
        givenRecurringDay.push(getDate);
      }
    }

    // Remove Duplicate Date using Set
    givenRecurringDay = [...new Set(givenRecurringDay)];

    if (!givenRecurringDay.length) {
      setValidateDate(true);
      const message = `Selected Dates Not Matching with ${startCase(
        dayOfWeek
      )}`;
      setDateValidateMessage(message);
    } else {
      setValidateDate(false);
      save({
        tenancyId,
        telemedicineId: telemedicineId || null,
        dayOfWeek,
        startsOn: moment.utc(startdate).toISOString(),
        // Previous start Date and End Date Flow
        // start: moment(
        //   moment(startsOn).format('MM/DD/YYYY') +
        //     ' ' +
        //     moment(start).format('HH:mm')
        // ).toISOString(),
        // end: moment(
        //   moment(startsOn).format('MM/DD/YYYY') +
        //     ' ' +
        //     moment(end).format('HH:mm')
        // ).toISOString(),
        start: moment(
          moment(startdate).format('MM/DD/YYYY') +
            ' ' +
            moment(start).format('HH:mm')
        ).toISOString(true),
        end: moment(
          moment(startdate).format('MM/DD/YYYY') +
            ' ' +
            moment(end).format('HH:mm')
        ).toISOString(true),
        durationWeeks: givenRecurringDay.length,
        durationDayArray: givenRecurringDay,
      });
    }
  };

  const selectDateRange = item => {
    const selectedDate = [item.selection];
    const startDate = moment(selectedDate[0].startDate).format('MM/DD/YYYY');
    const endDate = moment(selectedDate[0].endDate).format('MM/DD/YYYY');

    // Disable timezone based dates
    let getDateValue = findDstPeriodsDate(startDate);

    // set state maxDate properties in rangePicker
    setMaxDateDisable(new Date(getDateValue));

    const isDstStart = moment(startDate).isDST();
    const isDstEnd = moment(endDate).isDST();
    let message;

    if ((isDstStart && !isDstEnd) || (!isDstStart && isDstEnd)) {
      setValidateDate(true);
      message =
        'Availabilities between different timezones are not acceptable..Please click reset button';
      setDateValidateMessage(message);
    } else {
      setValidateDate(false);
    }
    setDateRange([item.selection]);
  };

  const findDstPeriodsDate = date => {
    let result;
    let startDate;
    startDate = moment(date).format('MM/DD/YYYY');
    let defineDst = DisplayDstSwitchDates(startDate);
    if (defineDst.firstDstDate !== null && defineDst.secondDstDate !== null) {
      const beginDstDate = moment(defineDst.firstDstDate).format('MM/DD/YYYY');
      const endDstDate = moment(defineDst.secondDstDate).format('MM/DD/YYYY');
      if (moment(beginDstDate).isSameOrAfter(startDate)) {
        result = moment(beginDstDate).format('MM/DD/YYYY');
      } else if (moment(endDstDate).isSameOrAfter(startDate)) {
        setMinDateDisable(new Date(beginDstDate));
        result = moment(endDstDate).format('MM/DD/YYYY');
      } else if (moment(endDstDate).isSameOrBefore(startDate)) {
        const addOneYear = moment(startDate)
          .add(1, 'years')
          .format('MM/DD/YYYY');
        let notEqualCurrentYear = DisplayDstSwitchDates(addOneYear);
        const nextBeginDstDate = moment(
          notEqualCurrentYear.firstDstDate
        ).format('MM/DD/YYYY');
        // const nextEndDstDate = moment(notEqualCurrentYear.secondDstDate).format(
        //   'MM/DD/YYYY'
        // );
        setMinDateDisable(new Date(endDstDate));
        result = moment(nextBeginDstDate).format('MM/DD/YYYY');
      }
      //  else if (moment(beginDstDate).isSameOrBefore(startDate)) {
      //   console.log('Else -----Date----');
      // }
    }
    return result;
  };

  const DisplayDstSwitchDates = startDate => {
    let year = new Date(startDate).getYear();
    if (year < 1000) year += 1900;
    let firstSwitch = 0;
    let secondSwitch = 0;
    let lastOffset = 99;
    // Loop through every month of the current year
    for (let i = 0; i < 12; i++) {
      // Fetch the timezone value for the month
      let newDate = new Date(Date.UTC(year, i, 0, 0, 0, 0, 0));
      let tz = (-1 * newDate.getTimezoneOffset()) / 60;

      // Capture when a timzezone change occurs
      if (tz > lastOffset) firstSwitch = i - 1;
      else if (tz < lastOffset) secondSwitch = i - 1;

      lastOffset = tz;
    }
    // Go figure out date/time occurrences a minute before
    // a DST adjustment occurs
    let secondDstDate = FindDstSwitchDate(year, secondSwitch);
    let firstDstDate = FindDstSwitchDate(year, firstSwitch);
    if (firstDstDate == null && secondDstDate == null)
      // return 'Daylight Savings is not observed in your timezone.';
      return {
        firstDstDate: null,
        secondDstDate: null,
      };
    else
      return {
        firstDstDate,
        secondDstDate,
      };
  };

  // Find DST startDate and EndDate with current year
  const FindDstSwitchDate = (year, month) => {
    // Set the starting date current year
    let baseDate = new Date(Date.UTC(year, month, 0, 0, 0, 0, 0));
    let changeDay = 0;
    let changeMinute = -1;
    let baseOffset = (-1 * baseDate.getTimezoneOffset()) / 60;
    let dstDate;

    // Loop to find the exact day a timezone adjust occurs
    for (let day = 0; day < 50; day++) {
      let tmpDate = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
      let tmpOffset = (-1 * tmpDate.getTimezoneOffset()) / 60;

      // Check if the timezone changed from one day to the next
      if (tmpOffset != baseOffset) {
        let minutes = 0;
        changeDay = day;

        // Back-up one day and grap the offset
        tmpDate = new Date(Date.UTC(year, month, day - 1, 0, 0, 0, 0));
        tmpOffset = (-1 * tmpDate.getTimezoneOffset()) / 60;

        // Count the minutes until a timezone change occurs
        while (changeMinute == -1) {
          tmpDate = new Date(Date.UTC(year, month, day - 1, 0, minutes, 0, 0));
          tmpOffset = (-1 * tmpDate.getTimezoneOffset()) / 60;

          // Determine the exact minute a timezone change
          // occurs
          if (tmpOffset != baseOffset) {
            // Back-up a minute to get the date/time just
            // before a timezone change occurs
            tmpOffset = new Date(
              Date.UTC(year, month, day - 1, 0, minutes - 1, 0, 0)
            );
            changeMinute = minutes;
            break;
          } else minutes++;
        }

        // Add a month (for display) since JavaScript counts
        // months from 0 to 11
        dstDate = tmpOffset.getMonth() + 1;

        // Pad the month as needed
        if (dstDate < 10) dstDate = '0' + dstDate;

        // Add the day and year
        dstDate += '/' + tmpOffset.getDate() + '/' + year + ' ';

        // Capture the time stamp
        tmpDate = new Date(
          Date.UTC(year, month, day - 1, 0, minutes - 1, 0, 0)
        );
        dstDate += tmpDate.toTimeString().split(' ')[0];
        return dstDate;
      }
    }
  };

  const onResetDate = () => {
    setDateRange([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
    ]);
    setMaxDateDisable(undefined);
    setMinDateDisable(new Date());
    setValidateDate(false);
  };

  const validate = () => {
    let valid = true;
    const nextState = {};
    if (!provider) {
      nextState.provider = 'Select a provider to select a tenancy.';
      valid = false;
    }
    if (!tenancyId) {
      nextState.tenancyId = 'Required';
      valid = false;
    }
    if (!dayOfWeek) {
      nextState.dayOfWeek = 'Required';
      valid = false;
    }
    // if (!startsOn) {
    //   nextState.startsOn = 'Required';
    //   valid = false;
    // }
    if (!start) {
      nextState.start = 'Required';
      valid = false;
    }
    if (!end) {
      nextState.end = 'Required';
      valid = false;
    }
    if (start && end && moment(start).isAfter(moment(end))) {
      nextState.end = 'End time must be after start time';
      nextState.start = 'Start time must be before end time';
      valid = false;
    }
    // if (!durationWeeks) {
    //   nextState.durationWeeks = 'Required';
    //   valid = false;
    // }
    setValidationErrors(nextState);
    return valid;
  };

  const onCloseModal = () => {
    onClose();
    setDateRange([]);
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onCloseModal}
      classes={{ paper: modal }}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>Recurring Availability</h2>
          </Grid>

          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onCloseModal}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        <AppBar position="static" color="default">
          <Tabs value={0}>
            <Tab label="Availability" />
          </Tabs>
        </AppBar>

        <TabPanel>
          <ProviderSearchBar
            clearable={false}
            label="For Provider"
            name="provider"
            placeholder="Search for a provider..."
            onSelect={onProviderChange}
            errorMessage={validationErrors.provider}
            className={selectInput}
          />

          <Select
            fullWidth
            disabled={!provider}
            variant="outlined"
            label="Location"
            name="tenancyId"
            value={tenancyId}
            error={validationErrors.tenancyId}
            helperText={validationErrors.tenancyId}
            onChange={event => {
              setTenancyId(event.target.value);
              setValidationErrors({
                ...validationErrors,
                [event.target.name]: false,
              });
            }}
            className={selectInput}
          >
            {tenancies.map(tenancy => (
              <MenuItem key={`menu-${tenancy.id}`} value={tenancy.id}>
                <ListItemText primary={tenancy.location} />
              </MenuItem>
            ))}
          </Select>

          <Select
            fullWidth
            variant="outlined"
            label="Day of Week"
            name="dayOfWeek"
            value={dayOfWeek}
            error={validationErrors.dayOfWeek}
            helperText={validationErrors.dayOfWeek}
            onChange={event => {
              setDayOfWeek(event.target.value);
              setValidationErrors({
                ...validationErrors,
                [event.target.name]: false,
              });
            }}
            className={input}
          >
            <MenuItem key="monday" value="monday">
              <ListItemText primary="Monday" />
            </MenuItem>
            <MenuItem key="tuesday" value="tuesday">
              <ListItemText primary="Tuesday" />
            </MenuItem>
            <MenuItem key="wednesday" value="wednesday">
              <ListItemText primary="Wednesday" />
            </MenuItem>
            <MenuItem key="thursday" value="thursday">
              <ListItemText primary="Thursday" />
            </MenuItem>
            <MenuItem key="friday" value="friday">
              <ListItemText primary="Friday" />
            </MenuItem>
            <MenuItem key="saturday" value="saturday">
              <ListItemText primary="Saturday" />
            </MenuItem>
            <MenuItem key="sunday" value="sunday">
              <ListItemText primary="Sunday" />
            </MenuItem>
          </Select>

          {/* Old dateSelect  */}
          {/* <DateSelect
            fullWidth
            variant="outlined"
            label="Starts on"
            format="MM/DD/YYYY"
            name="startsOn"
            placeholder="MM/DD/YYYY ex. 01/01/2001"
            value={new Date(startsOn)}
            onChange={date => {
              setStartsOn(moment(date).format('MM/DD/YYYY'));
              setValidationErrors({ ...validationErrors, startsOn: false });
            }}
            className={input}
          /> */}
          <div className="calendarSection">
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              onClick={onResetDate}
              className="mr-4"
            >
              Reset
            </Button>

            {validTimeZone ? (
              <>
                <DateRange
                  editableDateInputs={false}
                  dragSelectionEnabled={false}
                  preventSnapRefocus={true}
                  showSelectionPreview={true}
                  onChange={item => selectDateRange(item)}
                  moveRangeOnFirstSelection={false}
                  ranges={dateRange}
                  minDate={minDateDisable ? minDateDisable : new Date()}
                  // minDate={
                  //   minDateDisable
                  //     ? moment(minDateDisable)
                  //         .add(1, 'days')
                  //         .toDate()
                  //     : new Date()
                  // }
                  maxDate={maxDateDisable ? maxDateDisable : undefined}
                  months={1}
                  ariaLabels={{
                    monthPicker: 'month picker',
                    yearPicker: 'year picker',
                    prevButton: 'previous month button',
                    nextButton: 'next month button',
                  }}
                  className={input}
                />

                {validateDate ? (
                  <div className={alertText}>{dateValidateMessage}</div>
                ) : (
                  ''
                )}
              </>
            ) : (
              <DateRange
                editableDateInputs={false}
                dragSelectionEnabled={false}
                showSelectionPreview={true}
                onChange={item => setDateRange([item.selection])}
                moveRangeOnFirstSelection={false}
                ranges={dateRange}
                minDate={new Date()}
                months={1}
                ariaLabels={{
                  monthPicker: 'month picker',
                  yearPicker: 'year picker',
                  prevButton: 'previous month button',
                  nextButton: 'next month button',
                }}
                className={input}
              />
            )}
          </div>
          <TimeSelect
            fullWidth
            label="Start"
            name="start"
            time={start}
            increments={10}
            className={input}
            error={validationErrors.start}
            helperText={validationErrors.start}
            onChange={event => {
              setStart(event.target.value);
              setValidationErrors({
                ...validationErrors,
                [event.target.name]: false,
              });
            }}
          />

          <TimeSelect
            fullWidth
            label="End"
            name="end"
            time={end}
            increments={10}
            className={input}
            error={validationErrors.end}
            helperText={validationErrors.end}
            onChange={event => {
              setEnd(event.target.value);
              setValidationErrors({
                ...validationErrors,
                [event.target.name]: false,
              });
            }}
          />

          {/* <Select
            fullWidth
            variant="outlined"
            label="Distance"
            name="durationWeeks"
            value={durationWeeks}
            error={validationErrors.durationWeeks}
            helperText={validationErrors.durationWeeks}
            onChange={event => {
              setDurationWeeks(event.target.value);
              setValidationErrors({
                ...validationErrors,
                [event.target.name]: false,
              });
            }}
            className={input}
          > */}
          {/* <MenuItem key="2-weeks" value={2}>
              <ListItemText primary="2 Weeks" />
            </MenuItem>
            <MenuItem key="4-weeks" value={4}>
              <ListItemText primary="1 Month" />
            </MenuItem>
            <MenuItem key="8-weeks" value={8}>
              <ListItemText primary="2 Months" />
            </MenuItem>
            <MenuItem key="13-weeks" value={13}>
              <ListItemText primary="3 Months" />
            </MenuItem> */}
          {/* <MenuItem key="26-weeks" value={26}>
              <ListItemText primary="6 Months" />
            </MenuItem>
            <MenuItem key="52-weeks" value={52}>
              <ListItemText primary="1 Year" />
            </MenuItem> */}
          {/* </Select> */}
        </TabPanel>
      </DialogContent>

      <DialogActions>
        <Grid container justifyContent="flex-end" classes={{ container: actions }}>
          <Grid item xs={12} lg={12} className={btnCenter}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={onSave}
              disabled={validateDate}
              onClickValidation={validate}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

RecurringAvailabilityEditModal.propTypes = {
  open: PropTypes.bool.isRequired,
  save: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  classes: PropTypes.object,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
    fontColor: 'black',
  },
  alertText: {
    color: '#f44336',
    fontSize: '0.75rem',
    marginTop: '3px',
    textAlign: 'left',
    fontWeight: '400',
    lineHeight: '1.66',
    letterSpacing: '0.03333em',
    position: 'relative',
    left: '10px',
  },
  btnCenter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default withStyles(styles)(RecurringAvailabilityEditModal);
